<template>

  <a-drawer
      :maskClosable="true"
      width="50%"
      placement="left"
      :closable="true"
      @close="handleCancel"
      :visible="visible"
      :bodyStyle="{padding: '0'}"
      style="height: 100%;">

    <template slot="title">
      <a-dropdown-button>
        {{ country }}
        <a-menu slot="overlay" style="min-width: 90px">
          <a-menu-item key="美国" @click="handleCountry('美国')">美国</a-menu-item>
          <a-menu-item key="英国" @click="handleCountry('英国')">英国</a-menu-item>
          <a-menu-item key="澳大利亚" @click="handleCountry('澳大利亚')">澳大利亚</a-menu-item>
<!--          <a-menu-item key="泰国" @click="handleCountry('泰国')">泰国</a-menu-item>-->
<!--          <a-menu-item key="韩国" @click="handleCountry('韩国')">韩国</a-menu-item>-->
          <a-menu-item key="法国" @click="handleCountry('法国')">法国</a-menu-item>
          <a-menu-item key="加拿大" @click="handleCountry('加拿大')">加拿大</a-menu-item>
          <a-menu-item key="新西兰" @click="handleCountry('新西兰')">新西兰</a-menu-item>
        </a-menu>
        <a-icon slot="icon" type="global"/>
      </a-dropdown-button>
    </template>
    <a-menu mode="inline" :open-keys="openKeys" style="width: 100%" @openChange="onOpenChange">
      <template v-for="item in permissionList">
        <a-menu-item v-if="!item.children" :key="item.component">
          <router-link :to="item.url">
            <a-icon :type="item.icon"/>
            {{ item.name }}
          </router-link>
        </a-menu-item>
        <a-sub-menu v-else :key="item.authority">
          <span slot="title" class="submenu-title-wrapper"> <a-icon :type="item.icon"/> {{ item.name }} </span>
          <template v-for="child in item.children">
            <a-menu-item :key="child.component">
              <router-link :to="child.url">
                {{ child.name }}
              </router-link>
            </a-menu-item>
          </template>
        </a-sub-menu>
      </template>
    </a-menu>
  </a-drawer>

</template>

<script>
import {HttpMixins} from "@/mixins/http-mixins";


export default {
  name: "MenuShowMobile",
  mixins: [HttpMixins],
  data() {
    return {
      visible: false,
      country: '',
      permissionList: [],
      rootSubmenuKeys: [],
      openKeys: [],
      url: {
        list: window._CONFIG['domainURL'] + "/log/list",
      }
    }
  },
  methods: {
    reloadCountry() {
      let list = JSON.parse(localStorage.getItem('permissionList'));
      this.permissionList = [];
      this.rootSubmenuKeys = [];
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item.name === this.country) {
          this.permissionList = item.children;
          for (let j = 0; j < item.children.length; j++) {
            this.rootSubmenuKeys.push(item.children[j].name);
          }
          break;
        }
      }
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    show() {
      this.visible = true;
      let country = localStorage.getItem('country');
      if (!country) {
        localStorage.setItem('country', '美国');
        country = '美国';
      }
      this.country = country;
      this.reloadCountry();
    },
    handleCancel() {
      this.visible = false;
    },
    handleCountry(value) {
      if (value === '加拿大' || value === '新西兰') {
        this.$message.warning("开发中...");
        return;
      }
      localStorage.setItem('country', value);
      this.country = value;
      this.reloadCountry();
    },
  }
}
</script>


<style scoped>

</style>
